import { render, staticRenderFns } from "./TimeOffRequestDetailMenuCard.vue?vue&type=template&id=090b5ed2&"
import script from "./TimeOffRequestDetailMenuCard.vue?vue&type=script&lang=ts&"
export * from "./TimeOffRequestDetailMenuCard.vue?vue&type=script&lang=ts&"
import style0 from "./TimeOffRequestDetailMenuCard.vue?vue&type=style&index=0&id=090b5ed2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports